import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Video Icon
 *
 * @file Video.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

const Video = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 18 18" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.12 2H14.88C16.0508
        2 17 2.94916 17 4.12V13.88C17 15.0508 16.0508 16 14.88 16H3.12C1.94916
        16 1 15.0508 1 13.88V4.12C1 2.94916 1.94916 2 3.12 2ZM3.12 3.75C2.91565
        3.75 2.75 3.91565 2.75 4.12V13.88C2.75 14.0843 2.91565 14.25 3.12
        14.25H14.88C15.0843 14.25 15.25 14.0843 15.25 13.88V4.12C15.25 3.91565
        15.0843 3.75 14.88 3.75H3.12ZM7.05889 6.50609C7.02038 6.56897 7 6.64127
        7 6.715V11.2852C7 11.5061 7.17909 11.6852 7.4 11.6852C7.47373 11.6852
        7.54603 11.6648 7.60891 11.6263L11.0616 9.51176C11.3442 9.3387 11.433
        8.96932 11.2599 8.68673C11.2104 8.60589 11.1425 8.53793 11.0616
        8.48842L7.60891 6.37389C7.42052 6.25851 7.17426 6.3177 7.05889
        6.50609Z"
      fill="currentcolor"
    />
  </SvgIcon>
);

export default Video;
